var map = {
	"./building-delete": [
		2134,
		[
			134
		]
	],
	"./building-delete.vue": [
		2134,
		[
			134
		]
	],
	"./building-save": [
		9806,
		[
			806
		]
	],
	"./building-save.vue": [
		9806,
		[
			806
		]
	],
	"./building_settings-save": [
		3224,
		[
			224
		]
	],
	"./building_settings-save.vue": [
		3224,
		[
			224
		]
	],
	"./category-delete": [
		567,
		[
			567
		]
	],
	"./category-delete.vue": [
		567,
		[
			567
		]
	],
	"./category-save": [
		8563,
		[
			563
		]
	],
	"./category-save.vue": [
		8563,
		[
			563
		]
	],
	"./contact": [
		2967,
		[
			967
		]
	],
	"./contact.vue": [
		2967,
		[
			967
		]
	],
	"./corporation-delete": [
		3187,
		[
			187
		]
	],
	"./corporation-delete.vue": [
		3187,
		[
			187
		]
	],
	"./corporation-save": [
		7442,
		[
			442
		]
	],
	"./corporation-save.vue": [
		7442,
		[
			442
		]
	],
	"./corporation_settings-save": [
		843,
		[
			843
		]
	],
	"./corporation_settings-save.vue": [
		843,
		[
			843
		]
	],
	"./domain-delete": [
		1602,
		[
			602
		]
	],
	"./domain-delete.vue": [
		1602,
		[
			602
		]
	],
	"./domain-save": [
		6612,
		[
			612
		]
	],
	"./domain-save.vue": [
		6612,
		[
			612
		]
	],
	"./domain_settings-save": [
		9419,
		[
			419
		]
	],
	"./domain_settings-save.vue": [
		9419,
		[
			419
		]
	],
	"./floor-delete": [
		4605,
		[
			605
		]
	],
	"./floor-delete.vue": [
		4605,
		[
			605
		]
	],
	"./floor-save": [
		122,
		[
			122
		]
	],
	"./floor-save.vue": [
		122,
		[
			122
		]
	],
	"./images-upload": [
		3321,
		[
			321
		]
	],
	"./images-upload.vue": [
		3321,
		[
			321
		]
	],
	"./information": [
		5687,
		[
			687
		]
	],
	"./information.vue": [
		5687,
		[
			687
		]
	],
	"./partners": [
		9624,
		[
			624
		]
	],
	"./partners.vue": [
		9624,
		[
			624
		]
	],
	"./project-delete": [
		5015,
		[
			15
		]
	],
	"./project-delete.vue": [
		5015,
		[
			15
		]
	],
	"./project-save": [
		9339,
		[
			339
		]
	],
	"./project-save.vue": [
		9339,
		[
			339
		]
	],
	"./project_settings-save": [
		6683,
		[
			683
		]
	],
	"./project_settings-save.vue": [
		6683,
		[
			683
		]
	],
	"./prompt-modal": [
		4913,
		[
			913
		]
	],
	"./prompt-modal.vue": [
		4913,
		[
			913
		]
	],
	"./status-save": [
		4527,
		[
			527
		]
	],
	"./status-save.vue": [
		4527,
		[
			527
		]
	],
	"./tour-delete": [
		4186,
		[
			186
		]
	],
	"./tour-delete.vue": [
		4186,
		[
			186
		]
	],
	"./tour-save": [
		3209,
		[
			209
		]
	],
	"./tour-save.vue": [
		3209,
		[
			209
		]
	],
	"./unit-delete": [
		3843,
		[
			81
		]
	],
	"./unit-delete.vue": [
		3843,
		[
			81
		]
	],
	"./user-delete": [
		7262,
		[
			262
		]
	],
	"./user-delete.vue": [
		7262,
		[
			262
		]
	],
	"./user-save": [
		692,
		[
			692
		]
	],
	"./user-save.vue": [
		692,
		[
			692
		]
	],
	"./video-delete": [
		6176,
		[
			176
		]
	],
	"./video-delete.vue": [
		6176,
		[
			176
		]
	],
	"./video-save": [
		4133,
		[
			133
		]
	],
	"./video-save.vue": [
		4133,
		[
			133
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__(id)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 3616;
module.exports = webpackAsyncContext;